<mc-drawer>
  @if (state === viewStates.ADD_SITES) {
    <ng-template #headerTemplate>
      @if (showBackButton) {
        <mc-drawer-back-button (click)="location.back()"></mc-drawer-back-button>
      }
      <mc-drawer-title>Import/Update your list of sites via a CSV file</mc-drawer-title>
    </ng-template>
    <div class="drawer-card" [ngClass]="{loading: loading}">
      @if (loading) {
        <mc-progress-spinner class="loader"></mc-progress-spinner>
      } @else {
        <mc-drawer-card>
          <label class="drawer-card__content" tabindex="0" appDnd (fileDropped)="droppedCsv($event)">
            <mat-icon aria-hidden="false" svgIcon="drag" class="icon-drag" aria-label="Icon drag photo"></mat-icon>
            <span>
              <span class="select-trigger">Select</span>
              a CSV file from your, computer, or drag it here
            </span>
            <input
              type="file"
              data-testid="upload-file"
              id="upload-file"
              accept="text/csv"
              tabindex="0"
              (change)="loadCsvByInput($event)"
            />
            <span class="outline"></span>
          </label>
        </mc-drawer-card>
      }
    </div>
  } @else if (state === viewStates.PAYMENT_FORM) {
    <ng-template #headerTemplate>
      <mc-drawer-back-button (click)="back(viewStates.ADD_SITES)"></mc-drawer-back-button>
      <mc-drawer-title>Add Sites to Your Account</mc-drawer-title>
    </ng-template>
    <div class="add-sites-container">
      <mc-select-accessibility-plan (continuePayment)="openPaymentForm()"></mc-select-accessibility-plan>
    </div>
  } @else if (state === viewStates.COMPLETE_PAYMENT) {
    <ng-template #headerTemplate>
      <mc-drawer-back-button (click)="back(viewStates.PAYMENT_FORM)"></mc-drawer-back-button>
      <mc-drawer-title>Complete your payment</mc-drawer-title>
    </ng-template>
    <div class="add-sites-container">
      <div class="complete-payment-wrapper">
        <mc-payment-dialog (successfullyPaid)="openEmbedScript()"></mc-payment-dialog>
      </div>
    </div>
  } @else if (state === viewStates.WIDGET_SCRIPT) {
    <ng-template #headerTemplate>
      <mc-drawer-title>🎉 Congratulations! Now let's install your widget!</mc-drawer-title>
    </ng-template>
    <div class="add-sites-container add-sites-container__pb-0">
      <mc-embed-script title="Here Is Your Widget Script:"></mc-embed-script>
    </div>
  }
</mc-drawer>
